<template>
  <div id="camSettings">
    <h3 v-if="showTitle">{{ $t("langcfg.txtCamera") }}</h3>
    <br v-if="showTitle" />
    <!-- <el-row>
      <el-col
        :span="5"
        class="radio-label"
      >{{camCfg.mode.name}}:</el-col>
      <el-col
        :span="9"
        class="left"
      >
        <el-radio-group
          v-model="camCfg.mode.val"
          @change="camModeChanged"
        >
          <el-radio-button :label="0">RGB</el-radio-button>
          <el-radio-button :label="1">{{$t('langcfg.txtGray')}}</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <br /> -->
    <template v-for="(item, index) in camCfg">
      <el-row v-if="item.loop" :key="index">
        <el-col :span="8" style="text-align: left">
          <span style="position: relative; left: -9px; font-size: 28px">{{ item.name }}:</span>
        </el-col>
        <el-col :span="8">
          <el-slider
            class="myslider"
            :show-tooltip="false"
            v-model="item.val"
            input-size="mini"
            :min="item.min"
            :max="item.max"
            :step="item.step"
            @change="sliderChanged"
          ></el-slider>
        </el-col>
        <el-col :span="6">
          <el-input-number
            v-model="item.val"
            :min="item.min"
            :max="item.max"
            :step="item.step"
            @change="sliderChanged"
            @focus="handleClick(index)"
          ></el-input-number>
        </el-col>
      </el-row>
    </template>
    <br />
    <el-button class="btn-operator" @click="resetCamCfg" :style="`width: ${isDE ? 150 : 120}px`">{{
      $t("langcfg.txtReset")
    }}</el-button>
  </div>
</template>

<script>
import fileSys from "../../../fileoprators/fileSystem";
import { saveCamSettings } from "../../../settings";
import { CAMPLAMP } from "../../../settings/consts";
import { canConvertNumber, isObject, objectCopy } from "../../../shared/utils";
import { Message } from "../../../mixins";
import EVENTS from "../../../bus";
import SettingsOprator from "../../../settings/settingsoprator";
export default {
  name: "CamSettings",
  components: {},
  data() {
    return {
      camCfg: {},
      isDE: false
    };
  },
  props: {
    currentMode: { required: true, type: String },
    showTitle: { default: true }
  },
  created() {
    this.initShown();
  },
  mounted() {
    this.initCamCfg();
    this.$bus.$on("camInit", () => {
      this.initCamCfg();
    });
  },
  updated() {
    this.isDE = window.settings.language === "de";
  },
  mixins: [Message],
  methods: {
    initShown() {
      // 增益R、B反向
      this.camCfg = {
        mode: { val: 1, name: this.$t("langcfg.txtMode") }, // 0:rgb;1:灰度
        rgain: {
          val: 2.4,
          name: this.$t("langcfg.txtGain") + " B",
          min: 0,
          max: 10,
          step: 0.01,
          loop: true
        }, // 系数:2.8
        ggain: {
          val: 1.0,
          name: this.$t("langcfg.txtGain") + " G",
          min: 0,
          max: 10,
          step: 0.01,
          loop: true
        }, // 系数:1.0
        bgain: {
          val: 1.065,
          name: this.$t("langcfg.txtGain") + " R",
          min: 0,
          max: 10,
          step: 0.01,
          loop: true
        }, // 系数:1.065
        blacklevel: {
          val: 0,
          name: this.$t("langcfg.txtBlackLevel"),
          min: 0,
          max: 1,
          step: 0.01,
          loop: true
        }, // 0 ~ 1
        gamma: {
          val: 1.0,
          name: this.$t("langcfg.txtGamma"),
          min: 0.5,
          max: 2,
          step: 0.01,
          loop: true
        }
      };
    },
    handleClick(key) {
      let self = this;
      this.$bus.$emit(EVENTS.spreadKeyBoard, self.camCfg[key].val.toString(), (value) => {
        if (canConvertNumber(value)) {
          self.camCfg[key].val = Number(value);
          this.saveCamCfg();
        }
      });
    },
    sliderChanged() {
      this.saveCamCfg();
    },
    camModeChanged() {
      this.saveCamCfg();
    },
    initCamCfg() {
      if (!this.currentMode) return;
      let cam;
      if (this.currentMode === "blink" && window.captureSettings.isDrawBlink !== 1) {
        cam = window.camSettings[`${this.currentMode}_nature`].cam;
      } else if (this.currentMode === "nibut" && !window.captureSettings.SelectLight) {
        cam = window.camSettings[`${this.currentMode}_infrared`].cam;
      } else if (this.currentMode === "blink_nature" && window.captureSettings.isDrawBlink == 1) {
        cam = window.camSettings["blink"].cam;
      } else if (this.currentMode === "nibut_infrared" && window.captureSettings.SelectLight) {
        cam = window.camSettings["nibut"].cam;
      } else if (
        this.currentMode === "tearheight" &&
        !window.captureSettings.TearheightSelectLight
      ) {
        cam = window.camSettings[`${this.currentMode}_infrared`].cam;
      } else if (
        this.currentMode === "tearheight_infrared" &&
        window.captureSettings.TearheightSelectLight
      ) {
        cam = window.camSettings["tearheight"].cam;
      } else {
        cam = window.camSettings[this.currentMode].cam;
      }
      for (let key in cam) {
        this.camCfg[key].val = cam[key];
      }
    },
    saveCamCfg() {
      if (!this.currentMode) return;
      let cam;
      if (this.currentMode === "blink" && window.captureSettings.isDrawBlink !== 1) {
        cam = window.camSettings[`${this.currentMode}_nature`].cam;
      } else if (this.currentMode === "nibut" && !window.captureSettings.SelectLight) {
        cam = window.camSettings[`${this.currentMode}_infrared`].cam;
      } else if (this.currentMode === "blink_nature" && window.captureSettings.isDrawBlink == 1) {
        cam = window.camSettings["blink"].cam;
      } else if (this.currentMode === "nibut_infrared" && window.captureSettings.SelectLight) {
        cam = window.camSettings["nibut"].cam;
      } else if (
        this.currentMode === "tearheight" &&
        !window.captureSettings.TearheightSelectLight
      ) {
        cam = window.camSettings[`${this.currentMode}_infrared`].cam;
      } else if (
        this.currentMode === "tearheight_infrared" &&
        window.captureSettings.TearheightSelectLight
      ) {
        cam = window.camSettings["tearheight"].cam;
      } else {
        cam = window.camSettings[this.currentMode].cam;
      }
      for (let key in cam) {
        cam[key] = this.camCfg[key].val;
      }
      saveCamSettings(window.camSettings);
      this.$emit("change");
    },
    getDefaultCam() {
      // let tmp
      let toolsCalibCamPath = "/home/mw520/dea520/dea520_tools/dist/calib/camLampCfg.json";
      if (this.currentMode === "blink" && window.captureSettings.isDrawBlink !== 1) {
        this.currentMode = `${this.currentMode}_nature`;
      } else if (this.currentMode === "nibut" && !window.captureSettings.SelectLight) {
        this.currentMode = `${this.currentMode}_infrared`;
      } else if (this.currentMode === "blink_nature" && window.captureSettings.isDrawBlink == 1) {
        this.currentMode = "blink";
      } else if (this.currentMode === "nibut_infrared" && window.captureSettings.SelectLight) {
        this.currentMode = "nibut";
      } else if (
        this.currentMode === "tearheight" &&
        !window.captureSettings.TearheightSelectLight
      ) {
        this.currentMode = `${this.currentMode}_infrared`;
      } else if (
        this.currentMode === "tearheight_infrared" &&
        window.captureSettings.TearheightSelectLight
      ) {
        this.currentMode = "tearheight";
      }
      let settings = new SettingsOprator(toolsCalibCamPath, CAMPLAMP).getSettings()[
        this.currentMode
      ].cam;
      return settings;
      // let defaultCamLamp = fileSys.readJsonFile('/home/mw520/dea520/dea520_tools/dist/calib/camLampCfg.json')
      // if (this.currentMode === 'blink' && window.captureSettings.isDrawBlink !== 1) {
      //   defaultCamLamp = defaultCamLamp && defaultCamLamp[`${this.currentMode}_nature`]
      //   tmp = isObject(defaultCamLamp) && isObject(defaultCamLamp.cam) ? defaultCamLamp.cam : objectCopy(CAMPLAMP[`${this.currentMode}_nature`].cam)
      // } else if (this.currentMode === 'nibut' && !window.captureSettings.SelectLight) {
      //   defaultCamLamp = defaultCamLamp && defaultCamLamp[`${this.currentMode}_infrared`]
      //   tmp = isObject(defaultCamLamp) && isObject(defaultCamLamp.cam) ? defaultCamLamp.cam : objectCopy(CAMPLAMP[`${this.currentMode}_infrared`].cam)
      // } else {
      //   defaultCamLamp = defaultCamLamp && defaultCamLamp[this.currentMode]
      //   tmp = isObject(defaultCamLamp) && isObject(defaultCamLamp.cam) ? defaultCamLamp.cam : objectCopy(CAMPLAMP[this.currentMode].cam)
      // }
      // return tmp
    },
    resetCamCfg() {
      this.confirm(
        this.$t("langcfg.txtConfirmResetCurrent"),
        this.$t("langcfg.txtOK"),
        this.$t("langcfg.txtCancel")
      )
        .then(() => {
          if (this.currentMode === "blink" && window.captureSettings.isDrawBlink !== 1) {
            window.camSettings[`${this.currentMode}_nature`].cam = this.getDefaultCam();
          } else if (this.currentMode === "nibut" && !window.captureSettings.SelectLight) {
            window.camSettings[`${this.currentMode}_infrared`].cam = this.getDefaultCam();
          } else if (
            this.currentMode === "blink_nature" &&
            window.captureSettings.isDrawBlink == 1
          ) {
            window.camSettings["blink"].cam = this.getDefaultCam();
          } else if (this.currentMode === "nibut_infrared" && window.captureSettings.SelectLight) {
            window.camSettings["nibut"].cam = this.getDefaultCam();
          } else if (
            this.currentMode === "tearheight" &&
            !window.captureSettings.TearheightSelectLight
          ) {
            window.camSettings[`${this.currentMode}_infrared`].cam = this.getDefaultCam();
          } else if (
            this.currentMode === "tearheight_infrared" &&
            window.captureSettings.TearheightSelectLight
          ) {
            window.camSettings["tearheight"].cam = this.getDefaultCam();
          } else {
            window.camSettings[this.currentMode].cam = this.getDefaultCam();
          }
          saveCamSettings(window.camSettings);

          this.$nextTick(() => {
            this.notify(this.$t("langcfg.txtResetOK"), "", "success");
            this.initCamCfg();
            this.$emit("change");
          });
        })
        .catch((e) => {});
    }
  },
  watch: {
    currentMode(newVal) {
      if (newVal) {
        this.initCamCfg();
      }
    }
  },
  beforeDestory() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.left {
  text-align: left;
}
.radio-label {
  line-height: 49px;
}
.btn-operator:hover {
  color: @btn-hover-color;
  i {
    color: @btn-hover-color;
  }
}
.btn-operator:active {
  background: @btn-active-color;
}

.btn-operator {
  border: 1px gray solid;
  height: 45px;
  font-size: 23px;
}
.myslider {
  /deep/ .el-slider__bar {
    background: #409eff;
  }
}
</style>
<style lang="less">
#camSettings {
  .el-radio-button__inner {
    font-size: 23px;
  }
  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #3da13d;
    border-color: #3da13d;
    -webkit-box-shadow: -1px 0 0 0 #3da13d;
    box-shadow: -1px 0 0 0 #3da13d;
  }
  .el-radio-button__inner:hover {
    color: #3da13d;
  }
  .el-input-number {
    width: 130px;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    width: 29px;
  }
  .el-input-number .el-input__inner {
    padding-left: 35px;
    padding-right: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/CamSettings.vue